import {forwardRef} from 'react';
import styles from './Button.module.css';
import {classNames} from '../../utilities/classNames';

export const Button = forwardRef<HTMLButtonElement, UI.Button.Props>(function Button(
  {children, className, variant, tone, fullWidth, size, loading, ...attributes},
  ref,
) {
  const classes = classNames('Button', styles.Button, className, {
    [styles['full-width']]: fullWidth === true,
    [styles[`size-${size}`]]: `size-${size}` in styles,
    [styles[`tone-${tone}`]]: `tone-${tone}` in styles,
    [styles[`variant-${variant}`]]: `variant-${variant}` in styles,
    [styles.loading]: loading === true,
  });

  return (
    <button
      {...attributes}
      className={classes}
      ref={ref}
      aria-busy={loading ? true : undefined}
      disabled={loading || attributes.disabled}
    >
      {loading && (
        <svg
          className={styles.spinner}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <circle
            className={styles['spinner-track']}
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="3"
          />
          <path
            className={styles['spinner-head']}
            d="M12 2a10 10 0 0 1 10 10"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      )}
      {children}
    </button>
  );
});
